module.exports = __webpack_public_path__ + "static/media/charlotte.d3dcf6e2.woff2";